<template>
  <div>
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT CAMPAIGN DETAILS
      </h6>
      <EditTemplateDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <!-- <el-table
      class="table-responsive table-flush mt-8"
      header-row-class-name="thead-light table-th-colorblue  table-textcenter"
      :data="TagsData"
    > -->
      <el-table-column
        label="Campaign Name"
        prop="campaignname"
        min-width="180px"
        sortable
      >
        <template v-slot="{ row }">
          <p class=" text-black font-medium text-sm  text-center">
            {{ row.campaignname }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Spending"
        min-width="150px"
        prop="Spending"
        sortable
      >
        <template v-slot="{ row }">
          <p class=" text-black text-center text-sm  font-medium">
            {{ row.Spending }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Push Notification"
        min-width="180px"
        prop="pushNotification"
        sortable
      >
        <template v-slot="{ row }">
          <p class=" text-black font-medium text-sm  text-center">
            {{ row.pushNotification }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Start Date"
        min-width="150px"
        prop="startdate"
        sortable
      >
        <template v-slot="{ row }">
          <p class=" text-black text-center text-sm  font-medium">
            {{ row.startdate }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="End Date"
        min-width="150px"
        prop="enddate"
        sortable
      >
        <template v-slot="{ row }">
          <p class=" text-black text-center text-sm font-medium">
            {{ row.enddate }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="120px">
        <div class="flex items-center">
          <div class="flex items-center mr-4 cursor-pointer">
            <feather-icon
              @click="editModal = true"
              block
              icon="Edit3Icon"
              svgClasses="w-5"
            ></feather-icon>
          </div>
          <div class="flex items-center cursor-pointer">
            <feather-icon icon="Trash2Icon" svgClasses="w-5"></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>
<script>
import EditTemplateDetail from "./EditTemplateDetail";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import TagsData from "./TagsData";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTemplateDetail
  },

  data() {
    return {
      TagsData,
      currentPage: 1,
      editModal: false
    };
  }
};
</script>
